import React from 'react';
import styles from './Courses.module.css'
import { BsWhatsapp } from 'react-icons/bs';
  
const CourseList = ({ coursesData }) => {

    const courses = [
        {
          title: 'Python',
          duration: '16 hrs for 2 months',
          levels: ['A', 'B', 'C'],
          image: 'https://cdn-icons-png.flaticon.com/512/5968/5968544.png'
        },
        {
          title: 'Acting',
          duration: '16 hrs for 2 months',
          levels: ['A', 'B', 'C'],
          image: 'https://cdn-icons-png.flaticon.com/512/1778/1778557.png'
        },
        {
          title: 'Arabic Script Writing',
          duration: '16 hrs for 2 months',
          levels: ['A', 'B', 'C'],
          image: 'https://cdn-icons-png.flaticon.com/512/11145/11145247.png'
        },
        {
          title: 'Arabic Poems Writing',
          duration: '16 hrs for 2 months',
          levels: ['A', 'B', 'C'],
          image: 'https://cdn-icons-png.flaticon.com/512/11145/11145195.png'
        },
        {
          title: 'Life Coaching & Social Philosophy',
          duration: '16 hrs for 2 months',
          levels: ['A', 'B', 'C'],
          image: 'https://cdn-icons-png.flaticon.com/512/6548/6548156.png'
        },
        {
          title: 'Personal Training',
          duration: '16 hrs for 2 months',
          levels: ['A', 'B', 'C'],
          image: 'https://cdn-icons-png.flaticon.com/512/6591/6591708.png'
        },
        {
          title: 'Sports Nutrition',
          duration: '16 hrs for 2 months',
          levels: ['A', 'B', 'C'],
          image: 'https://cdn-icons-png.flaticon.com/512/2446/2446118.png'
        },
        {
          title: 'Mastering Private Tutoring',
          duration: '16 hrs for 2 months',
          levels: ['A', 'B', 'C'],
          image: 'https://cdn-icons-png.flaticon.com/512/12608/12608508.png'
        },
        {
          title: 'Microsoft Word Course',
          duration: '16 hrs for 2 months',
          levels: ['A', 'B', 'C'],
          image: 'https://cdn-icons-png.flaticon.com/512/732/732078.png'
        },
        {
          title: 'Microsoft Excel Course',
          duration: '16 hrs for 2 months',
          levels: ['A', 'B', 'C'],
          image: 'https://cdn-icons-png.flaticon.com/512/1/1396.png'
        },
        {
          title: 'Microsoft PowerPoint Course',
          duration: '16 hrs for 2 months',
          levels: ['A', 'B', 'C'],
          image: 'https://cdn-icons-png.flaticon.com/512/732/732074.png'
        }
      ];



      function generateWhatsAppMessage(courseTitle) {

       
        
        const phoneNumber='96181184763'
      
        // Create a message with item specifications
        let message = `Hello, can i get more details about the following course:*${courseTitle}`;
        
       
        // Encode the message for a URL
        const encodedMessage = encodeURIComponent(message);
      
      
        // Open WhatsApp Web with the message to the specified phone number
        window.open(`https://wa.me/${phoneNumber}?text=${encodedMessage}`);
      
        // You can also focus the new window if needed
        // newWindow.focus();
      }
      
  return (
    <div className={styles.coursesContainer}>
      <h1><span>Our</span>  Courses</h1>
      <div className={styles.coursesWrapper}>
      {courses?.map((course,index) => (
        <div key={index} className={styles.courses}>
            <div className={styles.img}>
          <img src={course.image} alt={course.title} />
          </div>
          <h3>{course.title}</h3>
          <p><strong>Duration:</strong> {course.duration}</p>
          <p><strong>Levels: </strong>{course.levels.join(', ')}</p>
          <button onClick={()=>{generateWhatsAppMessage(course.title)}}>Enroll via WhatsApp <BsWhatsapp/></button>
        </div>
        
      ))}
      </div>

      <div className="not_sign__shape">
              <img className="circle" src="/assets/img/icon/sign/circle.png" alt="img not found"/>
                  <img className="zigzag" src="/assets/img/icon/sign/zigzag.png" alt="img not found"/>
                  <img className="dot" src="/assets/img/icon/sign/dot.png" alt="img not found"/>
                  <img className="flower" src="/assets/img/icon/sign/flower.png" alt="img not found"/> 
                  
                 

                  
              </div> 
    </div>
  );
};

export default CourseList;
